import { getBooleanFeatureFlag } from '@atlassian/jira-portfolio-3-common/src/feature-flags';

// Some of the ARJ integration relies on the state of this feature flag that are in the tiered rollout rules
export const isMigrateArjTeamsToPlatformTeamsEnabledFFKey = () =>
	'com.atlassian.rm.jpo.jpo3cloud.migrateToAtlassianTeams';

// Second feature flag added to better handle sites moving between tiers while tiered rollout not progressing
// https://hello.atlassian.net/browse/JPO-23699
export const isMigrateToAtlassianTeamsRolloutEnabledFFKey = () =>
	'com.atlassian.rm.jpo.jpo3cloud.migrate-to-atlassian-teams-rollout';

/*
 * Checks if either flag is true
 * When second feature flag is to rollout to 100% prior to migration, the frontend will reliant only on useTwpTeams
 */
const isMigrateArjTeamsToPlatformTeamsEnabled = () =>
	getBooleanFeatureFlag(isMigrateArjTeamsToPlatformTeamsEnabledFFKey(), false, true) ||
	getBooleanFeatureFlag(isMigrateToAtlassianTeamsRolloutEnabledFFKey(), false, true);

export default isMigrateArjTeamsToPlatformTeamsEnabled;
